import React from 'react';
import { Box, Stack } from '@mui/material';
import { BusinessOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components';
import {
  CustomerNameEdit,
  CustomerEmailEdit,
  CustomerPhoneEdit,
  CustomerDepartmentEdit,
  CustomerLocationEdit,
  CustomerRoleEdit
} from '../fields';

/**
 * CustomerInformationSection - Manages customer contact and profile information
 * Contains all customer-related fields organized in logical groups
 */
export const CustomerInformationSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader 
        icon={<BusinessOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />} 
        title="Customer Information" 
      />
      <SectionPaper>
        <Stack spacing={2}>
          {/* Primary contact information */}
          <Stack direction="row" gap={2}>
            <CustomerNameEdit />
            <CustomerEmailEdit />
            <CustomerPhoneEdit />
          </Stack>
          
          {/* Organizational information */}
          <Stack direction="row" gap={2}>
            <CustomerDepartmentEdit />
            <CustomerLocationEdit />
            <CustomerRoleEdit />
          </Stack>
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default CustomerInformationSection;
